import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommerceHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "CommerceHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.723 2.92a3 3 0 0 0-2.457-.906L12.164 3.4a2.44 2.44 0 0 0-2.072 1.616 2.42 2.42 0 0 0 .578 2.56l1.907 1.907-9.79 9.788a1.234 1.234 0 0 0-.002 1.745l.003.003 1.457 1.456a1.234 1.234 0 0 0 1.744.003l.003-.003c.483-.48.484-1.262.003-1.744q0-.003-.003-.004l-.578-.577 9.778-9.792c.483-.48.485-1.262.004-1.744l-.004-.004-2.79-2.747 14.1-1.385a.54.54 0 0 1 .589.604l-1.792 13.634-2.929-2.93a1.23 1.23 0 0 0-.875-.362c-.329 0-.642.132-.873.368l-7.518 7.617a3.4 3.4 0 0 0-3.588 5.595 3.404 3.404 0 0 0 4.813 0 3.39 3.39 0 0 0 .616-3.94l6.562-6.65 2.05 2.05a2.44 2.44 0 0 0 2.522.588 2.44 2.44 0 0 0 1.649-2l1.82-13.64a3 3 0 0 0-.82-2.49z"
    })
  }));
};
CommerceHubIcon.displayName = 'CommerceHubIcon';